import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import { NotificationItem } from './InternalNoticeCenter';
import {Modal, InputField} from './Common';
import TextareaAutosize from 'react-autosize-textarea';
import { View, Text, StyleSheet, Dimensions, ScrollView, TouchableOpacity, TextInput } from 'react-native'
import Ionicon from 'react-ionicons'

import './HeaderUI.css';

class HeaderUI extends Component {
  constructor(props) {
    super(props)
    this.state = {
      query: "",
      user: (typeof FakeData.getData("yoo") === 'object') ? FakeData.getData("yoo") : { mySport: [] },
      msgs: [],
      requests: [],
      events: [],
      notices: [],
      dummyTeams: [],
      teams: [],
      leagues: [],
      dummyLeagues: [],
      isSearching: false,
      isLogged: false
    }

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    const _that = this;
    this._isMounted = true;
    this.getData()
    this.getDummyTeams()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getData() {
    if (!this._isMounted) {
      return;
    }
    this.setState({
      user: !this.props.isLogged ? FakeData.guest : (typeof FakeData.getData("yoo") === 'object') ? FakeData.getData("yoo") : {},
      msgs: !this.props.isLogged ? [] : FakeData.listify(FakeData.getData("yoo").messages),
      requests: !this.props.isLogged ? [] : FakeData.listify(FakeData.getData("yoo").relations),
      events: !this.props.isLogged ? [] : FakeData.listify(FakeData.getData("yoo").events),
      notices: !this.props.isLogged ? [] : FakeData.listify(FakeData.getData("yoo").notices),
      teams: !this.props.isLogged ? [] : this.getTeams(),
      leagues: !this.props.isLogged ? [] : this.getLeagues(),
      isLogged: this.props.isLogged
    });

    const _that = this

    setTimeout(() => {
      _that.getData()
    }, 1000)
  }

  toggleSearch = () => {
    const { query } = this.state;
    if (query === "") {
      return;
    } else {
      const url = "/search?q=" + query;
      window.location = url;
    }
  }

  getDummyTeams = () => {
    const _that = this;
    FakeData.post("/getDummyTeams.php", {}, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        _that.setState({ dummyTeams: res });
      }
    })
  }

  getTeams = () => {
    const list = [];
    const { user } = this.state;
    if (!user.myTeams || !user.teamsFollowed) {
      return list;
    } else {
      FakeData.listify(user.myTeams).forEach((item, i) => {
        if (!this.inTeams(item, list)) {
          item.filterTag = "Teams I play for";
          list.push(item);
        }
      })

      FakeData.listify(user.teamsFollowed).forEach((item, i) => {
        if (!this.inTeams(item, list)) {
          item.filterTag = item.sport;
          list.push(item);
        }
      })

      return list;
    }
  }

  getLeagues = () => {
    //leagues
    const list = [];
    const { user } = this.state;
    if (!user.myLeauges || !user.leagues) {
      return list;
    } else {
      FakeData.listify(user.myLeauges).forEach((item, i) => {
        if (!this.inTeams(item, list)) {
          item.filterTag = "Tournments I play in";
          list.push(item);
        }
      })

      FakeData.listify(user.leagues).forEach((item, i) => {
        if (!this.inTeams(item, list)) {
          item.filterTag = item.sport;
          list.push(item);
        }
      })

      return list;
    }
  }

  inTeams = (team, teams = []) => {
    let bool = false;
    for (let index = 0; index < teams.length; index++) {
      const _team = teams[index];
      if (_team.id === team.id) {
        bool = true;
        break;
      }
    }

    return bool;
  }

  getUnreadNotices = (notices) => {
    const list = []
    FakeData.listify(notices).forEach((item, i) => {
      if (item.context.status === "unread") {
        list.push(item)
      }
    })

    return list;
  }

  getUnreadMGS = (notices) => {
    const list = []
    FakeData.listify(notices).forEach((item, i) => {
      if (item.unread > 0) {
        list.push(item)
      }
    })

    return list;
  }

  render() {
    const { query, user, dummyTeams, teams, leagues, isLogged } = this.state;
    if (!isLogged) {
      return (
        <nav className="navbar navbar-default navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#defaultNavbar1"><span className="sr-only">Toggle navigation</span><span className="icon-bar"></span><span className="icon-bar"></span><span className="icon-bar"></span></button>
              <a className="navbar-brand"><img src="images/supotsu_logo.svg" className="logo" alt="Supotsu" /></a>
            </div>
            <div className="nav navbar-nav navbar-right">
              <div className="sign_in_btns">
                <a href="/register" title="Register" className="gen_btn large_btn">Register</a>
                <a href="/login" title="Login" className="gen_btn large_btn clear_btn">Login</a>
              </div>
            </div>
          </div>
        </nav>
      );
    }
    return (
      <nav className="navbar navbar-default navbar-fixed-top" style={{
        zIndex: 3
      }}>
        <div className="container-fluid">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#defaultNavbar1"><span className="sr-only">Toggle navigation</span><span className="icon-bar"></span><span className="icon-bar"></span><span className="icon-bar"></span></button>
            <Link to={{pathname:this.props.homePath}} className="navbar-brand"><img src="images/supotsu_logo.svg" className="logo" alt="Supotsu" /></Link>
          </div>
          <div className="new_menu_holder">
            <ul className="new_menu">
              <li className="active"><Link to={{pathname:this.props.homePath}}>Home</Link></li>
              <li><Link className="top_menu_avatar" to={{ pathname: "/profile/" + this.state.user.username, search: '?sInit=about' }}>Profile</Link></li>
              <TeamsMenu sports={user.mySport} yourTeams={teams} otherTeams={[]} />
              <TournmentsMenu sports={user.mySport} yourTeams={leagues} otherTeams={[]} />
              <li id="new_menu_all_sports" tabIndex={0} onBlur={() => {
                //document.querySelector("a.all-sports-trigger").click()
              }}><a className="new_menu_dropdown all-sports-trigger">All Sports</a>
                <ul className="new_menu_dropdown_menu_2 all_sports" id="new_menu_all_sports_ul">
                  <li className="sports_search popular_sports">
                    <h3 style={{ backgroundImage: "none", color: "#fff" }}><a href="/all-sports" title="View All" style={{ color: "#fff!important", padding: 0 }}>View All</a></h3>
                    <h3>My Sports</h3>
                    {
                      FakeData.listify(user.mySport).map((item, i) => {
                        if (i > 5) {
                          return null;
                        }
                        return (
                          <a key={i} className={FakeData.nullify(item.name).toLowerCase()}>{item.name}</a>
                        )
                      })
                    }
                  </li>
                </ul>
              </li>
              <li><Link className="" to={{ pathname: "/dashboard/" + this.state.user.username, search: '' }}>Dashboard</Link></li>
              <li className="active"><a onClick={() => {
                this.props.onLogout();
              }}>Logout</a></li>
            </ul>
          </div>
          <div className="new_menu_search_holder">
            <div className="top_search search-bar-header" style={{ right: "255px" }}>
              <div style={{ width:"200px" }}>
                <input type="text" value={query} placeholder="Search Supotsu" onChange={(e) => {
                  this.setState({ query: e.target.value })
                }} style={{ width:"calc(100% - 35px)" }} />
                <i src="images/search_friend.svg" className="material-icons" alt="Search Supotsu" onClick={this.toggleSearch.bind(this)}>search</i>
              </div>
            </div>
            <div className="notification_holder" style={{ height: "50px" }}>
              <Link className="top_menu_avatar" to={{ pathname: "/profile/" + this.state.user.username, search: '?sInit=about' }}>
                <img src={(this.state.user) ? this.state.user.image : ".././images/default_avatar.svg"} alt="My Avatar" />
              </Link>
              <HelpIcon/>
              <NotificationMessagIcon label="Recent Messages" to={{ pathname: "/chats" }} toTitle="Open Chats" classOne="message_icon" classTwo="message_no" items={this.state.msgs} icon={(this.getUnreadMGS(this.state.msgs).length === 0) ? ".././images/message_icon_gry.svg" : ".././images/message_icon_wht.svg"} />
              <NotificationIcon label="Friend Requests" to={{ pathname: "/add-friends/" + this.state.user.username }} toTitle="Find New Friends" classOne="friend_icon" classTwo="friend_no" items={this.state.requests} icon={(this.getUnreadNotices(this.state.requests).length === 0) ? ".././images/friend_icon_gry.svg" : ".././images/friend_icon_wht.svg"} />
              <NotificationIcon label="Events" to={{ pathname: "/profile/" + this.state.user.username, search: "?sInit=events" }} toTitle="See More" classOne="event_icon" classTwo="event_no" items={this.state.events} icon={(this.getUnreadNotices(this.state.events).length === 0) ? ".././images/event_icon_gry.svg" : ".././images/event_icon_wht.svg"} />
              <NotificationIcon label="Notifications" to={{ pathname: "/profile/" + this.state.user.username, search: "?sInit=notice" }} toTitle="See More" classOne="message_icon" classTwo="message_no" items={this.state.notices} icon={(this.getUnreadNotices(this.state.notices).length === 0) ? ".././images/notice_icon_gray.svg" : ".././images/notice_icon.svg"} />
            </div>
          </div>
        </div>
        <SearchPopUpApp isOpen={this.state.isSearching} onCancel={() => this.setState({ isSearching: false })} />
      </nav>
    );
  }
}

class MySportsMenu extends Component {
  constructor(props) {
    super(props);

  }

  render = () => {
    return (
      <ul className="new_menu_dropdown_menu my_sports_teams" id="new_menu_my_sports_ul">
        <li id="my_sports_play">
          <h3>Sports I play</h3>
          <a className="cricket">Cricket</a>
          <a className="golf">Golf</a>
          <a className="hockey">Hockey</a>
          <a className="soccer">Soccer</a>
        </li>
        <li id="my_sports_follow">
          <h3>Sports I follow</h3>
          <a className="boxing">Boxing</a>
          <a className="cricket">Cricket</a>
          <a className="golf">Golf</a>
          <a className="hockey">Hockey</a>
          <a className="motorsport">Motor Racing</a>
          <a className="rugby">Rugby</a>
          <a href="#soccer_teams" className="soccer">Soccer</a>
          <a className="tennis">Tennis</a>
        </li>
      </ul>
    )
  }
}

class TeamsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "Teams I play for",
      isFocus: false
    }
  }

  componentDidMount() {
    this.isFocus = false;
  }

  getDummy = () => {

  }

  createRandomWord = (length) => {
    var consonants = 'bcdfghjklmnpqrstvwxyz',
      vowels = 'aeiou',
      rand = function (limit) {
        return Math.floor(Math.random() * limit);
      },
      i, word = '', length = parseInt(length, 10),
      consonants = consonants.split(''),
      vowels = vowels.split('');
    for (i = 0; i < length / 2; i++) {
      var randConsonant = consonants[rand(consonants.length)],
        randVowel = vowels[rand(vowels.length)];
      word += (i === 0) ? randConsonant.toUpperCase() : randConsonant;
      word += i * 2 < length - 1 ? randVowel : '';
    }
    return word;
  }

  render = () => {
    const { sports, yourTeams, otherTeams } = this.props;
    const { active, isFocus } = this.state;
    const arr = FakeData.listify(yourTeams);
    let rem = arr.length % 5;
    rem = rem === 1 ? 4 : rem === 4 ? 1 : rem === 2 ? 3 : rem == 3 ? 2 : rem;
    return (
      <li className="team-drop-menu" tabIndex={0} ref={"myMenu"} onBlur={() => this.setState({ isFocus: false })}>
        <a className="new_menu_dropdown" onClick={() => this.setState({ isFocus: !isFocus })}>Teams</a>
        {isFocus &&
          <div className="team-drop-menu-ctx">
            <div className="team-drop-menu-ctx-cat">
              <div className={active === "Teams I play for" ? "active" : ""} onClick={() => {
                this.setState({ active: "Teams I play for", isFocus: true })
              }}>Teams I play for</div>
              {
                FakeData.listify(sports).map((item, i) => {
                  return (
                    <div className={active === item.name ? "active" : ""} key={i} onClick={() => {
                      this.setState({ active: item.name, isFocus: true })
                    }}>
                      {item.name}
                    </div>
                  )
                })
              }
            </div>
            <div className="team-drop-menu-ctx-items">
              {
                arr.map((item, i) => {
                  if (item.filterTag !== active) {
                    return null;
                  }
                  return (
                    <div key={i} onClick={()=>{
                      item.type = "T"
                      const path = FakeData.getPath(item);
                      //console.log(path)
                      window.location = path.pathname+path.search
                    }}>
                      <img src={item.image} />
                      <span>{item.name}</span>
                    </div>
                  )
                })
              }
              {
                arr.map((item, i) => {
                  if (item.filterTag === active) {
                    return null;
                  }
                  return (
                    <div key={i} style={{ cursor: "not-allowed" }}>
                      <img src={item.image} style={{ opacity: "0.3" }} />
                      <span style={{ opacity: "0.3" }}>{item.name}</span>
                    </div>
                  )
                })
              }
              {
                FakeData.getDummy(rem).map((item, i) => {
                  return (
                    <div key={i} style={{ borderRightColor: "#fff" }}>

                    </div>
                  )
                })
              }
            </div>
          </div>
        }
      </li>
    )
  }
}

class TournmentsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "Tournments I play in",
      isFocus: false
    }
  }

  componentDidMount() {
    this.isFocus = false;
  }

  getDummy = () => {

  }

  createRandomWord = (length) => {
    var consonants = 'bcdfghjklmnpqrstvwxyz',
      vowels = 'aeiou',
      rand = function (limit) {
        return Math.floor(Math.random() * limit);
      },
      i, word = '', length = parseInt(length, 10),
      consonants = consonants.split(''),
      vowels = vowels.split('');
    for (i = 0; i < length / 2; i++) {
      var randConsonant = consonants[rand(consonants.length)],
        randVowel = vowels[rand(vowels.length)];
      word += (i === 0) ? randConsonant.toUpperCase() : randConsonant;
      word += i * 2 < length - 1 ? randVowel : '';
    }
    return word;
  }

  render = () => {
    const { sports, yourTeams, otherTeams } = this.props;
    const { active, isFocus } = this.state;
    const arr = FakeData.listify(yourTeams);
    let rem = arr.length % 5;
    rem = rem === 1 ? 4 : rem === 4 ? 1 : rem === 2 ? 3 : rem == 3 ? 2 : rem;
    return (
      <li className="team-drop-menu" tabIndex={0} ref={"myMenu"} onBlur={() => this.setState({ isFocus: false })}>
        <a className="new_menu_dropdown" onClick={() => this.setState({ isFocus: !isFocus })}>Tournments</a>
        {isFocus &&
          <div className="team-drop-menu-ctx">
            <div className="team-drop-menu-ctx-cat">
              <div className={active === "Tournments I play in" ? "active" : ""} onClick={() => {
                this.setState({ active: "Tournments I play in", isFocus: true })
              }}>Tournments I play in</div>
              {
                FakeData.listify(sports).map((item, i) => {
                  return (
                    <div className={active === item.name ? "active" : ""} key={i} onClick={() => {
                      this.setState({ active: item.name, isFocus: true })
                    }}>
                      {item.name}
                    </div>
                  )
                })
              }
            </div>
            <div className="team-drop-menu-ctx-items">
              {
                arr.map((item, i) => {
                  if (item.filterTag !== active) {
                    return null;
                  }
                  return (
                    <div key={i} onClick={()=>{
                      item.type = "L"
                      item.user = item.hash
                      const path = FakeData.getPath(item);
                      //console.log(path, item)
                      window.location = path.pathname+path.search
                    }}>
                      <img src={item.image} />
                      <span>{item.name}</span>
                    </div>
                  )
                })
              }
              {
                arr.map((item, i) => {
                  if (item.filterTag === active) {
                    return null;
                  }
                  return (
                    <div key={i} style={{ cursor: "not-allowed" }}>
                      <img src={item.image} style={{ opacity: "0.3" }} />
                      <span style={{ opacity: "0.3" }}>{item.name}</span>
                    </div>
                  )
                })
              }
              {
                FakeData.getDummy(rem).map((item, i) => {
                  return (
                    <div key={i} style={{ borderRightColor: "#fff" }}>

                    </div>
                  )
                })
              }
            </div>
          </div>
        }
      </li>
    )
  }
}

class HelpIcon extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      isReport: false,
      isSuggest: false
    }
  }

  render(){
    const { isOpen, isReport, isSuggest } = this.state
    return(
      <div className="top_menu_avatar notification">
        <Ionicon icon="md-help-circle" color={isOpen?"#fff":"#ccc"} onClick={()=>{
          this.setState({ isOpen: !isOpen });
        }} fontSize="50px" />
        {isOpen &&
          <div className="notice-board-pop" style={{
            width:"200px"
          }}>
            <div className="notice-board-pop-head">
              <span>{"Quick Help"}</span>
            </div>
            <div className="notice-board-pop-body">
              {
                [
                  {
                    label: "Settings",
                    url: "/profile/" + FakeData.getData("yoo").username+"?sInit=settings"
                  },
                  {
                    label: "Support Inbox",
                    url: "/support"
                  },
                  {
                    label: "Report Problem",
                    url: false
                  },
                  {
                    label: "Make Suggestion",
                    url: false
                  }
                ].map((item, i) => {
                  return (
                    <TouchableOpacity className="quick-help-link" activeOpacity={0.9} key={i} style={{
                      paddingHorizontal: 10,
                      paddingVertical: 5
                    }} onPress={()=>{
                      if(item.url){
                        this.setState({ isOpen: false });
                      } else{
                        if(item.label==="Report Problem"){
                          this.setState({ isReport: true });
                        } else if(item.label==="Make Suggestion"){
                          this.setState({ isSuggest: true });
                        }
                        this.setState({ isOpen: false });
                      }
                    }}>
                      {item.url ?
                        <a href={item.url}>{item.label}</a> :
                        <Text>{item.label}</Text>
                      }
                    </TouchableOpacity>
                  )
                })
              }
            </div>
            <div className="notice-board-pop-foot">
              <Link to={{pathname:""}}>{"FAQs"}</Link>
            </div>
          </div>
        }
        {isSuggest &&
          <MakeASuggestion isOpen={isSuggest} onClose={()=>{
            this.setState({ isSuggest: false });
          }} />
        }
        {isReport &&
          <ReportAProblem isOpen={isReport} onClose={()=>{
            this.setState({ isReport: false });
          }} />
        }
      </div>
    )
  }
}

class MakeASuggestion extends Component{
  constructor(p){
    super(p)
    this.state = {
      text: ""
    }
  }

  submit = () => {
    const _that = this;
    var data = new FormData();
    const {text} = this.state;

    data.append("body", text);
    data.append("type", "suggestion");
    data.append("hasScreenshot", 'false');
    data.append("file", null);
    data.append("context", "Suggestion");
    data.append("user", JSON.stringify({
      id: FakeData.you().id,
      type: "F",
      name: FakeData.you().name,
      email: FakeData.you().email
    }));
    //console.log(data)
    FakeData.upload(FakeData.apiURL+"/admin/support/new-message", data, {
      success(res){
        if(res.error){
          FakeData.alert(res.message);
          return;
        } else{
          if(_that.props.onClose){
            _that.props.onClose();
          }
        }
      }
    }, true);
  }

  render(){
    const {text} = this.state;
    return(
      <Modal onClose={this.props.onClose} isOpen={this.props.isOpen}>
        <View className="add-place" style={{
          width: "45vw",
          maxHeight: "45vw"
        }}>
          <h2>Suggestion Box</h2>
          <div className={""} style={{
            display: "flex",
            alignItems: "flex-start",
          }}>
            <Ionicon icon={"md-bulb"} color="#aaa" fontSize={"36px"} className="material-icons" style={{
              margin: "5px 5px",
              width: 36,
              color: "#aaa"
            }}/>
            <TextareaAutosize rows={3} defaultValue={text} placeholder={"Write something... \nAt least 50 characters"} style={{
              flex: 1,
              resize: "none",
              border: "1px solid #ccc",
              padding: "5px 10px",
              minHeight: "36px"
            }} onChange={(e) => {
              this.setState({ text: e.target.value });
            }} />
          </div>
          <button disabled={text.length < 50} onClick={() => {
            this.submit()
          }} className="button">Submit</button>
        </View>
      </Modal>
    )
  }
}

class ReportAProblem extends Component{
  constructor(p){
    super(p)
    this.state = {
      text: "",
      content:"",
      otherContent:"",
      hasScreenshot: false,
      file: false,
      filePreview: false,
      fileToken: Date.now(),
      items: [
        "",
        "Profile",
        "Club",
        "Team",
        "Tournament",
        "Group",
        "Institution",
        "Search",
        "Suggestion",
        "Notifications",
        "Photo",
        "Video",
        "Chat",
        "Game",
        "Event",
        "Other"
      ]
    }
  }

  submit = () => {
    const _that = this;
    var data = new FormData();
    const {text, content, file, otherContent, hasScreenshot} = this.state;

    data.append("body", text);
    data.append("type", "bug");
    data.append("hasScreenshot", hasScreenshot);
    data.append("file", file);
    data.append("context", content==="Other"?otherContent:content);
    data.append("user", JSON.stringify({
      id: FakeData.you().id,
      type: "F",
      name: FakeData.you().name,
      email: FakeData.you().email
    }));
    //console.log(data)
    FakeData.upload(FakeData.apiURL+"/admin/support/new-message", data, {
      success(res){
        if(res.error){
          FakeData.alert(res.message);
          return;
        } else{
          if(_that.props.onClose){
            _that.props.onClose();
          }
        }
      }
    }, true);
  }

  render(){
    const {text, items, content, fileToken, otherContent, hasScreenshot} = this.state;
    return(
      <Modal onClose={this.props.onClose} isOpen={this.props.isOpen}>
        <View className="add-place" style={{
          width: "45vw",
          maxHeight: "6-vw"
        }}>
          <h2>Report Problem</h2>
          <InputField label={"Where is the problem?"} style={{
            height: "auto",
            marginBottom: 10
          }}>
            <select style={{
              marginTop: 5
            }} onChange={(e)=>{
              const {value} = e.target;
              this.setState({ content: value });
            }} value={content} ref={(el)=>{
              if(el){
                el.setAttribute("style","border:1px solid #ccc!important")
              }
            }}>
              {
                items.map((item, i)=>{
                  return(
                    <option value={item} key={i}>{item}</option>
                  )
                })
              }
            </select>
          </InputField>
          {content==="Other" &&
            <InputField label={"Give a title for 'other problem'"} style={{
              height: "auto",
              marginBottom: 10
            }}>
              <input style={{
              marginTop: 5
            }} value={otherContent} ref={(el)=>{
                if(el){
                  el.setAttribute("style","border:1px solid #ccc!important;padding:4px!important")
                }
              }} onChange={(e)=>{
                const {value} = e.target;
                this.setState({ otherContent: value });
              }}/>
            </InputField>
          }
          <InputField label={"What happened?"} style={{
            height: "auto",
            marginBottom: 10
          }}>
            <div className={""} style={{
              display: "flex",
              alignItems: "flex-start",
              marginTop: 5
            }}>
              <Ionicon icon={"md-bulb"} color="#aaa" fontSize={"36px"} className="material-icons" style={{
                margin: "5px 5px",
                width: 36,
                color: "#aaa"
              }}/>
              <TextareaAutosize rows={3} defaultValue={text} placeholder={`Briefly explain what happened and what steps we can take to reproduce the problem ...`} style={{
                flex: 1,
                resize: "none",
                border: "1px solid #ccc",
                padding: "5px 10px",
                minHeight: "36px",
                maxHeight: "180px"
              }} onChange={(e) => {
                this.setState({ text: e.target.value });
              }} />
            </div>
          </InputField>
          <div className="split-input">
            <InputField key={fileToken} label={"Attachment"} style={{
              height: "auto",
              marginBottom: 10
            }}>
              <div style={{
                marginTop: 10
              }} onClick={() => {
                this.setState({
                  hasScreenshot: !hasScreenshot
                });
              }}><input type="radio" readOnly name="terms" checked={hasScreenshot} /><label style={{ color: "#000" }}><Text>Include screenshot?</Text></label></div>
              {hasScreenshot &&
                <div style={{
                  margin: "10px 0px",
                  background: "#ddd",
                  width: this.state.filePreview?"100%":"50%",
                  lineHeight: "35px",
                  height: "35px",
                  borderRadius: "2px",
                  border: "1px solid #ccc",
                  position: "relative",
                  padding: "0px 10px",
                  display:"flex",
                  flexDirection: "row",
                  alignItems: 'center',
                }}>
                  <Text style={{
                    flex: 1,
                    fontWeight: '600'
                  }}>Select File</Text>
                  <Ionicon icon="md-camera" fontSize="25px" color="#aaa" style={{
                    height: "25px",
                    width: "25px"
                  }}/>
                  <input type="file" accept="image/*" style={{
                    position: 'absolute',
                    opacity: 0,
                    right: 0,
                    left: 0,
                    width: '100%'
                  }} onChange={(e)=>{
                    const {files} = e.target;
                    const _that = this;
                    if(files[0]){
                      let reader = new FileReader();
                      const file = files[0];
                      this.setState({
                        file
                      });

                      reader.onloadend = () => {
                        _that.setState({
                          filePreview: reader.result?reader.result:false
                        });
                      };
                      reader.readAsDataURL(file);
                    }
                  }}/>
                </div>
              }
            </InputField>
            {this.state.filePreview && hasScreenshot &&
              <div style={{
                display: 'flex',
                flexDirection: 'column',
              }}>
                <img src={this.state.filePreview} style={{
                  height: "150px",
                  width: "150px",
                  marginBottom: 5
                }} />
                <button style={{
                  border: 'none',
                  background: "#4ac",
                  color: "#fff",
                  lineHeight: "25px",
                  height: "25px",
                  padding: "0px 10px",
                }} onClick={()=>{
                  this.setState({ file: false, filePreview: false, fileToken: Date.now() });
                }}>Remove</button>
              </div>
            }
          </div>
          {(text.length < 50 || (content === "" || (content === "Other" && otherContent==="")) || (hasScreenshot && !this.state.file)) &&
            <code style={{
              display: "block",
              padding: 10,
              marginBottom: 10
            }}>
              <ul>
                <li style={{
                  textDecoration: content!==""?"line-through":""
                }}>Select problem</li>
                {content === "Other" &&
                  <li style={{
                    textDecoration: otherContent!==""?"line-through":""
                  }}>Specify the problem</li>
                }
                <li style={{
                  textDecoration: text.length > 50?"line-through":""
                }}>Tell us about the problem</li>
                {hasScreenshot &&
                  <li style={{
                    textDecoration: this.state.file?"line-through":""
                  }}>Select screenshot</li>
                }
              </ul>
            </code>
          }
          {!(text.length < 50 || (content === "" || (content === "Other" && otherContent==="")) || (hasScreenshot && !this.state.file)) &&
            <button onClick={() => {
              this.submit();
            }} className="button">Submit</button>
          }
        </View>
      </Modal>
    )
  }
}

class NotificationIcon extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  componentDidMount() {

  }

  readNotice(id) {
    FakeData.post("/readNotice.php?auth0", { id: id }, {
      success: ((res) => {

      }),
      error: ((err) => {

      })
    })
  }

  close() {
    this.setState({
      isOpen: false
    });
  }

  getUnreadNotices = (notices) => {
    const list = []
    FakeData.listify(notices).forEach((item, i) => {
      if (item.context.status === "unread") {
        list.push(item)
      }
    })

    return list;
  }

  willLeave() {
    this.setState({
      isOpen: false
    });
  }

  render() {
    const { isOpen, isActive } = this.state
    const { items } = this.props
    const { yoo } = FakeData.data
    const unread = this.getUnreadNotices(items)
    if (!this.isOpen) {
      return (
        <div ref={"root"} className={"notification " + this.props.classOne} tabIndex={0} onBlur={() => {
          if (isActive) {
            //this.refs.root.focus()
            return;
          }

          //this.setState({ isOpen: false })
          //this.refs.root.blur()
        }}>
          <div style={{ cursor: "pointer", height: "50px" }} onClick={() => {
            if (!FakeData.shared("notificationIcon")) {
              FakeData.shared("notificationIcon", this)
              this.setState({
                isOpen: !isOpen
              });
            } else {
              FakeData.shared("notificationIcon").willLeave()
              FakeData.shared("notificationIcon", this)
              this.setState({
                isOpen: !isOpen
              });
            }
          }}>
            {(unread.length > 0) &&
              <div className={"count " + this.props.classTwo}>{unread.length}</div>
            }
            <img src={this.props.icon} alt="" />
          </div>
          {isOpen &&
            <div className="notice-board-pop">
              <div className="notice-board-pop-head">
                <span>{this.props.label}</span>
                <Link to={{ pathname: "/profile/" + yoo.username, search: "?sInit=settings" }}>Settings</Link>
              </div>
              <div className="notice-board-pop-body">
                {
                  FakeData.listify(items).map((item, i) => {
                    return (
                      <NotificationItem mountedCallBack={() => this.setState({ isActive: true })} unMountedCallBack={() => this.setState({ isActive: false })} style={{ padding: "0px 0px 5px 10px", borderBottom: (i === (FakeData.listify(items).length - 1)) ? 'none' : '' }} notice={item} key={"notice_" + item.id} />
                    )
                  })
                }
                {FakeData.listify(items).length === 0 &&
                  <div className="empty">Nothing at the moment!</div>
                }
              </div>
              <div className="notice-board-pop-foot">
                <Link to={this.props.to}>{this.props.toTitle}</Link>
              </div>
            </div>
          }
        </div>
      )
    }
    return (
      <div className={"notification " + this.props.classOne}>
        <div style={{ cursor: "pointer", height: "50px" }} onClick={() => {
          if (!FakeData.shared("notificationTray")) {
            FakeData.shared("notificationTray", this)
            this.setState({
              isOpen: true
            });
          } else {
            FakeData.shared("notificationTray").close()
            FakeData.shared("notificationTray", this)
            this.setState({
              isOpen: (FakeData.shared("notificationTray").state.isOpen) ? false : true
            });
          }
        }}>
          {(this.props.items.length > 0) &&
            <div className={"count " + this.props.classTwo}>{this.props.items.length}</div>
          }
          <img src={this.props.icon} alt="" />
        </div>
        {(this.state.isOpen && this.props.classOne === "message_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Messages {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    if (FakeData.isMounted("chatApp")) {
                      this.readNotice(item.id)
                      this.close()
                      if (item === null) {
                        FakeData.shared("chatApp").onUserSelect(item)
                      } else {
                        FakeData.shared("chatApp").getChatById(item.id, item.otherUser)
                      }
                      return
                    }

                    FakeData.shared("mainThread").addToChats(item)
                    this.readNotice(item.id)
                    this.close()
                  }}>
                    {item.isGroup &&
                      <div className="notification-tray-item-icon group">
                        {
                          item.users.map((user, x) => {
                            if (x > 1) {
                              return null;
                            }
                            return (
                              <img src={user.image} key={x} />
                            )
                          })
                        }
                      </div>
                    }
                    {!item.isGroup &&
                      <img src={item.image} className="notification-tray-item-icon" />
                    }

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{(item.isGroup) ? item.body.user.name + " : " + item.body.text : item.body.text}</span>
                    </div>
                    {(item.isGroup && item.isAdmin) &&
                      <i className="material-icons">settings</i>
                    }
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">Open Chats</Link>
          </div>
        }
        {(this.state.isOpen && this.props.classOne === "friend_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Friend Requests {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    FakeData.shared("mainThread").addToChats(item)
                    this.readNotice(item.id)
                  }}>
                    {item.isGroup &&
                      <div className="notification-tray-item-icon group">
                        {
                          item.users.map((user, x) => {
                            if (x > 1) {
                              return null;
                            }
                            return (
                              <img src={user.image} key={x} />
                            )
                          })
                        }
                      </div>
                    }
                    {!item.isGroup &&
                      <img src={item.image} className="notification-tray-item-icon" />
                    }

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{item.last_msg.body}</span>
                    </div>
                    {(item.isGroup && item.isAdmin) &&
                      <i className="material-icons">settings</i>
                    }
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">View More Requests</Link>
          </div>
        }
        {(this.state.isOpen && this.props.classOne === "event_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Event Invites {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    //FakeData.shared("mainThread").addToChats(item)
                    //this.readNotice(item.id)
                  }}>
                    <img src={item.body.user.image} className="notification-tray-item-icon" />

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{item.body.text}</span>
                      <div className="actions-field"></div>
                    </div>
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">View More Invites</Link>
          </div>
        }
      </div>
    );
  }
}

class NotificationMessagIcon extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  componentDidMount() {

  }

  willLeave() {
    this.setState({
      isOpen: false
    });
  }

  readNotice(id) {
    FakeData.post("/readNotice.php?auth0", { id: id }, {
      success: ((res) => {

      }),
      error: ((err) => {

      })
    })
  }

  close() {
    this.refs.root.blur();
  }

  getUnreadMGS = (notices) => {
    const list = []
    FakeData.listify(notices).forEach((item, i) => {
      if (item.unread > 0) {
        list.push(item)
      }
    })

    return list;
  }

  addToChats = (convo) => {
    //console.log(convo)
    if (FakeData.isMounted("chatApp")) {
      this.readNotice(convo.id)
      this.willLeave()
      if (convo === null) {
        FakeData.shared("chatApp").onUserSelect(convo)
      } else {
        FakeData.shared("chatApp").getChatById(convo.id, convo.otherUser)
      }
      return
    }

    FakeData.shared("mainThread").addToChats(convo)
    this.willLeave()
    this.readNotice(convo.id)
  }

  render() {
    const { isOpen } = this.state
    const { items } = this.props
    const { yoo } = FakeData.data
    const unread = this.getUnreadMGS(items)
    if (!this.isOpen) {
      return (
        <div ref={"root"} className={"notification " + this.props.classOne} tabIndex={0} onClick={() => {
          if (!FakeData.shared("notificationIcon")) {
            FakeData.shared("notificationIcon", this)
            this.setState({
              isOpen: !isOpen
            });
          } else {
            FakeData.shared("notificationIcon").willLeave()
            FakeData.shared("notificationIcon", this)
            this.setState({
              isOpen: !isOpen
            });
          }
        }}>
          <div style={{ cursor: "pointer", height: "50px" }}>
            {(unread.length > 0) &&
              <div className={"count " + this.props.classTwo}>{unread.length}</div>
            }
            <img src={this.props.icon} alt="" />
          </div>
          {isOpen &&
            <div className="notice-board-pop">
              <div className="notice-board-pop-head">
                <span>{this.props.label}</span>
                <Link to={{ pathname: "/profile/" + yoo.username, search: "?sInit=settings" }}>Settings</Link>
              </div>
              <div className="notice-board-pop-body">
                {
                  FakeData.listify(items).map((item, i) => {
                    if(item.last_msg === null){
                      return null;
                    }
                    return (
                      <MSGItem addToChats={this.addToChats.bind(this)} style={{ padding: "0px 0px 5px 10px", borderBottom: (i === (FakeData.listify(items).length - 1)) ? 'none' : '' }} notice={item} key={"notice_" + item.id} />
                    )
                  })
                }
                {FakeData.listify(items).length === 0 &&
                  <div className="empty">Nothing at the moment!</div>
                }
              </div>
              <div className="notice-board-pop-foot">
                <Link to={this.props.to}>{this.props.toTitle}</Link>
              </div>
            </div>
          }
        </div>
      )
    }
    return (
      <div className={"notification " + this.props.classOne}>
        <div style={{ cursor: "pointer", height: "50px" }} onClick={() => {
          if (!FakeData.shared("notificationTray")) {
            FakeData.shared("notificationTray", this)
            this.setState({
              isOpen: true
            });
          } else {
            FakeData.shared("notificationTray").close()
            FakeData.shared("notificationTray", this)
            this.setState({
              isOpen: (FakeData.shared("notificationTray").state.isOpen) ? false : true
            });
          }
        }}>
          {(this.props.items.length > 0) &&
            <div className={"count " + this.props.classTwo}>{this.props.items.length}</div>
          }
          <img src={this.props.icon} alt="" />
        </div>
        {(this.state.isOpen && this.props.classOne === "message_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Messages {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    if (FakeData.isMounted("chatApp")) {
                      this.readNotice(item.id)
                      this.close()
                      if (item === null) {
                        FakeData.shared("chatApp").onUserSelect(item)
                      } else {
                        FakeData.shared("chatApp").getChatById(item.id, item.otherUser)
                      }
                      return
                    }

                    FakeData.shared("mainThread").addToChats(item)
                    this.readNotice(item.id)
                    this.close()
                  }}>
                    {item.isGroup &&
                      <div className="notification-tray-item-icon group">
                        {
                          item.users.map((user, x) => {
                            if (x > 1) {
                              return null;
                            }
                            return (
                              <img src={user.image} key={x} />
                            )
                          })
                        }
                      </div>
                    }
                    {!item.isGroup &&
                      <img src={item.image} className="notification-tray-item-icon" />
                    }

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{(item.isGroup) ? item.body.user.name + " : " + item.body.text : item.body.text}</span>
                    </div>
                    {(item.isGroup && item.isAdmin) &&
                      <i className="material-icons">settings</i>
                    }
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">Open Chats</Link>
          </div>
        }
        {(this.state.isOpen && this.props.classOne === "friend_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Friend Requests {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    FakeData.shared("mainThread").addToChats(item)
                    this.readNotice(item.id)
                  }}>
                    {item.isGroup &&
                      <div className="notification-tray-item-icon group">
                        {
                          item.users.map((user, x) => {
                            if (x > 1) {
                              return null;
                            }
                            return (
                              <img src={user.image} key={x} />
                            )
                          })
                        }
                      </div>
                    }
                    {!item.isGroup &&
                      <img src={item.image} className="notification-tray-item-icon" />
                    }

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{item.last_msg.body}</span>
                    </div>
                    {(item.isGroup && item.isAdmin) &&
                      <i className="material-icons">settings</i>
                    }
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">View More Requests</Link>
          </div>
        }
        {(this.state.isOpen && this.props.classOne === "event_icon") &&
          <div className="notification-tray" onMouseLeave={() => this.close()}>
            <div className="header-notice">Event Invites {(this.props.items.length > 0) ? "(" + this.props.items.length + ")" : ""}</div>
            {
              this.props.items.map((item, i) => {
                return (
                  <div key={i} className="notification-tray-item" onClick={() => {
                    //FakeData.shared("mainThread").addToChats(item)
                    //this.readNotice(item.id)
                  }}>
                    <img src={item.body.user.image} className="notification-tray-item-icon" />

                    <div className="notification-tray-item-body">
                      <span>{item.name}</span>
                      <span>{item.body.text}</span>
                      <div className="actions-field"></div>
                    </div>
                  </div>
                )
              })
            }
            {this.props.items.length === 0 &&
              <span style={{ display: "block", lineHeight: "30px", borderBottom: "0.3px solid #ddd", textAlign: "center" }}>No New Notifications</span>
            }
            <Link to="">View More Invites</Link>
          </div>
        }
      </div>
    );
  }
}

class MSGItem extends Component {
  constructor(props){
    super(props)
    this.state = {
      item : props.notice,
      chatSystem: {status:"offline"},
      msgs: []
    }
  }

  componentDidMount(){
    this._isMounted = true;
    const _that = this;
    const {item, msg} = this.state;

    try {
        this.chat = this.chat = FakeData.socket_connect(_that.state.item.id+"-list-notice");
        let _user = FakeData.getData("yoo");
        delete _user.settings;
        delete _user.hash_key;
        this.chat.on("chat_open", (data)=>{
          _that.setState({ chatSystem: data });
          _that.chat.emit("join_chat", {id: _that.state.item.id});
        })

        this.chat.on("message",(data) => {
            //console.log(data)
            let _msg = data;
            _msg['isYou'] = FakeData.getData("yoo").id === data.user.id?true:false;
            if(!_msg['isYou']){
                _msg['status'] = 'delivered';
            }
            item.last_msg = _msg;
            
            _that.setState({item});
            if(_that.props.onNewMessage){
                _that.props.onNewMessage(item)
            }
        })
    } catch (error) {
        this.chat = false;
    }
  }

  componentWillUnmount(){
    this._isMounted = false;
    if(this.chat){
        this.chat.emit("leave_chat",{id: this.state.item.id});
        this.chat.disconnect();
        this.chat = false
    };
  }

  markRead = (bool) => {
    const { notice } = this.props
    this.refs.more.blur()
  }

  markUnread = () => {
    const { notice } = this.props
    this.refs.more.blur()
  }

  blockType = () => {
    const { notice } = this.props
    this.refs.more.blur()
  }

  unblockType = () => {
    const { notice } = this.props
    this.refs.more.blur()
  }


  render = () => {
    const { notice, style } = this.props;
    const { isOpen } = this.state
    return (
      <div className={(notice.unread > 0) ? "internal-notice-center-body-item active" : "internal-notice-center-body-item"} style={this.props.style}>
        <img src={notice.otherUser.image} onClick={() => this.props.addToChats(notice)} />
        <div className="internal-notice-center-body-item-ctx">
          <span onClick={() => this.props.addToChats(notice)}><strong>{notice.otherUser.name}</strong> {notice.last_msg.body}</span>
          <div className="internal-notice-center-body-item-ctx-time" onClick={() => this.props.addToChats(notice)}>
            {window.moment(notice.last_msg.date).calendar()}
          </div>
          <div className="internal-notice-center-body-item-ctx-more" tabIndex={0} onFocus={() => {
            if (this.props.mountedCallBack) {
              this.props.mountedCallBack.call(this)
            }
          }} onBlur={() => {
            if (this.props.unMountedCallBack) {
              this.props.unMountedCallBack.call(this)
            }
          }} ref={"more"}>
            <i className="material-icons">more_horiz</i>
            <div className="internal-notice-center-body-item-ctx-more-act">
              {(notice.unread > 0) &&
                <span onClick={this.markRead.bind(this)}>Mark read</span>
              }
              {(notice.unread === 0) &&
                <span onClick={this.markUnread.bind(this)}>Mark unread</span>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class SearchPopUpApp extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false }
  }

  render = () => {
    const { } = this.props
    const { isOpen } = this.state
    return (
      <div className={(isOpen) ? "search-pop-up-app open-search-app" : "search-pop-up-app close-search-app"} style={{ display: (isOpen) ? 'block' : 'none' }}>

      </div>
    );
  }
}

export const HeaderShimmer = () => {
  return(
    <nav className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header" style={{
          background: "#fff",
        }}>

        </div>
      </div>
    </nav>
  )
}

export default HeaderUI;



// WEBPACK FOOTER //
// ./src/components/HeaderUI.js